import RuntimeConfigError from "_shared/runtime-config/runtime-config-error";

/**
 * Shows why the page cannot start, in place of the application.
 *
 * Plain DOM, not React and MUI: this runs before the application is imported, because everything
 * the application imports may read the configuration that just failed to load.
 */
export function showRuntimeConfigFailure(container: HTMLElement, error: unknown): void {
  const detail = error instanceof RuntimeConfigError ? error.message : `${String(error)}`;

  const alert = document.createElement("div");
  alert.setAttribute("role", "alert");
  Object.assign(alert.style, {
    fontFamily: "Roboto, Helvetica, Arial, sans-serif",
    maxWidth: "640px",
    margin: "64px auto",
    padding: "24px",
    border: "1px solid #d32f2f",
    borderRadius: "4px",
    color: "#5f2120",
    backgroundColor: "#fdeded",
  });

  const heading = document.createElement("h1");
  heading.textContent = "Attorney Hub cannot start";
  Object.assign(heading.style, { fontSize: "1.25rem", margin: "0 0 12px" });

  const explanation = document.createElement("p");
  explanation.textContent =
    "This site's configuration could not be loaded, so the page does not know which server to use. " +
    "Reloading will not help until the configuration is fixed.";
  explanation.style.margin = "0 0 12px";

  const reason = document.createElement("pre");
  reason.textContent = detail;
  Object.assign(reason.style, { whiteSpace: "pre-wrap", margin: "0", fontSize: "0.875rem" });

  alert.append(heading, explanation, reason);
  container.replaceChildren(alert);
}
